// Funktionsstufe des Builds: Jede Stufen-Abgabe zeigt nur die bis dahin abgenommenen Funktionen.
export const FEATURE_LEVEL = 11;
export const feature = {
  party: FEATURE_LEVEL >= 4,
  contentEngine: FEATURE_LEVEL >= 5,
  editor: FEATURE_LEVEL >= 6,
  meta: FEATURE_LEVEL >= 7,
  online: FEATURE_LEVEL >= 8,
  pubLife: FEATURE_LEVEL >= 9,
};
